import React from 'react'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faSearch, faTimes} from '@fortawesome/free-solid-svg-icons'

import "./SearchBar.scss"
import MarkersList from "./MarkersList";
import SearchField from "./SearchField";

export default class SearchBar extends React.Component {
  render() {
    return (
      <div className={`SearchBar ${this.props.searchBarVisible ? 'expanded' : 'collapsed'}`}>

        {this.props.searchBarVisible ? (
          <button onClick={() => this.props.toggleSearchBar()} className="collapse-btn">
            <FontAwesomeIcon icon={faTimes}/>
          </button>
        ) : (
          <button onClick={() => this.props.toggleSearchBar()} className="expand-btn">
            <FontAwesomeIcon icon={faSearch}/>
          </button>
        )}

        <div className="search-field-wrapper">
          <h3>Cerca la sede più vicina</h3>
          <SearchField setHome={this.props.setHome}/>
        </div>
        <MarkersList
          setActiveMarker={this.props.setActiveMarker}
          activeMarker={this.props.activeMarker}
          markers={this.props.markers}
        />
      </div>
    )
  }
}

SearchBar.propTypes = {
  setHome: PropTypes.func.isRequired,
  setActiveMarker: PropTypes.func.isRequired,
  markers: PropTypes.array.isRequired,
  activeMarker: PropTypes.object,
  searchBarVisible: PropTypes.bool.isRequired,
  toggleSearchBar: PropTypes.func.isRequired,
}
